import tableAccidentSection from "../../components/tableAccidentSection/index.vue";

export default {
    name: "tablePage",
    components: {
        tableAccidentSection
    },
    methods: {}
};